import App from './App';
import 'dayjs/locale/es';
import { MantineProvider, ColorSchemeProvider } from '@mantine/core';
import { useHotkeys, useLocalStorage } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import GlobalStyles from './GlobalStyles';
import { DatesProvider } from '@mantine/dates';

function Root() {

	// Hooks
	const [colorScheme, setColorScheme] = useLocalStorage({
		key: 'mantine-color-scheme',
		defaultValue: 'light',
		getInitialValueInEffect: true,
	});
	const toggleColorScheme = (value) => setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'));
	useHotkeys([['mod+J', () => toggleColorScheme()]]);

	return (
		<ColorSchemeProvider
			colorScheme={colorScheme}
			toggleColorScheme={toggleColorScheme}
		>
			<MantineProvider
				withGlobalStyles
				withNormalizeCSS
				theme={{
					colorScheme: colorScheme,
					fontFamily: 'Montserrat, sans-serif',
					headings: { fontFamily: 'Montserrat, sans-serif' },
					colors: {
						mainPurple: ['#7405CC', '#6A05B9', '#5F04A7', '#550494', '#4A0382', '#40036F', '#35025D', '#2A024A', '#200138', '#150125'],
						secondaryPurple: ['#F6EBFF', '#E8D2FA', '#D1A0F7', '#B86BF5', '#A440F3', '#9827F3', '#911BF3', '#7E12D9', '#700DC1', '#6004A9'],
						orange1: ['#FF9F0A', '#E89109', '#D18208', '#B97407', '#A26506', '#8B5705', '#744805', '#5D3A04', '#462B03', '#2E1D02'],
						orange2: ['#FF6C25', '#E86222', '#D1581E', '#B94F1B', '#A24518', '#8B3B14', '#743111', '#5D270D', '#461D0A', '#2E1407'],
						purple2: ['#8944AB', '#7D3E9B', '#70388C', '#64317C', '#572B6D', '#4B255D', '#3E1F4E', '#32193E', '#25132F', '#190C1F'],
						pink1: ['#F66F8D', '#E06580', '#C95B73', '#B35167', '#9D475A', '#863D4D', '#703240', '#592833', '#431E26', '#2D141A'],
						pink2: ['#DC3F6A', '#C83960', '#B43457', '#A02E4D', '#8C2843', '#78223A', '#641D30', '#501727', '#3C111D', '#280B13'],
						shiraz: ['#AF123D', '#9F1037', '#8F0F32', '#7F0D2C', '#6F0B27', '#5F0A21', '#50081C', '#400716', '#300511', '#20030B'],
						blueGray: ['#F3F3FE', '#E4E6ED', '#C8CAD3', '#A9ADB9', '#9093A4', '#808496', '#767C91', '#656A7E', '#585E72', '#4A5167'],
						co2Green: ['#F1FBEB', '#E6F1DC', '#CCE1B9', '#B0D193', '#98C373', '#89BA5F', '#81B653', '#6EA043', '#608E3A', '#507B2C']
					},
					primaryColor: 'mainPurple',
					focusRing: 'never',
					primaryShade: 4,
					other: {
						chartPurple: ['#E6D2F6', '#CCA4EC', '#9B49DA', '#4A0B82'],
						chartOrange: ['#FFE5BC', '#FF9F0B']
					}
				}}
			>
				<GlobalStyles />
				<Notifications />
				<ModalsProvider>
					<DatesProvider settings={{ locale: 'es', firstDayOfWeek: 0, weekendDays: [0] }}>
						<App />
					</DatesProvider>
				</ModalsProvider>
			</MantineProvider>
		</ColorSchemeProvider>
	);

}

export default Root;
